<template>
  <div :class="{ fixedNavbar: isfixTab }" id="testNavBar">
    <div class="page-header" @mouseleave="closeMenu">
      <div class="nav-block">
        <a href="/home" class="left-logo"></a>

        <ul class="nav-list-left navUl">
          <li
            v-for="(item, index) in navList"
            :key="index"
            class="nav-list--active"
            :class="{ hover: open === index }"
            @mouseenter="openMenu(index)"
          >
            <div class="li-link">
              <a :href="item.href || 'javascript:;'" class="link">{{ item.title }}</a>
            </div>
          </li>
        </ul>

        <div class="nav-icons">
          <a href="http://www.conexbanninger.com/" target="_blank" rel="noopener" class="icon-link"></a>
          <div class="icon"></div>
        </div>
      </div>

      <!-- 三级下拉：内容随鼠标停留的上一级联动，不再是写死的一套 -->
      <div class="nav-drop">
        <div class="subMenu" :class="{ 'is-open': level1.length > 0 }">
          <div class="subContent" :class="{ 'subContent--dense': level1.length > 4 }">
            <a
              v-for="(c, ci) in level1"
              :key="'l1' + ci"
              :href="link(c)"
              :target="c.blank ? '_blank' : null"
              :rel="c.blank ? 'noopener' : null"
              class="subList"
              :class="{ 'nav-list--active': l1 === ci && hasChildren(c) }"
              @mouseenter="pickL1(ci)"
            >{{ c.title }}</a>
          </div>
        </div>

        <div class="subMenu sub-2" :class="{ 'is-open': level2.length > 0 }">
          <div class="subContent secondary" :class="{ 'subContent--dense': level2.length > 4 }">
            <a
              v-for="(c, ci) in level2"
              :key="'l2' + ci"
              :href="link(c)"
              :target="c.blank ? '_blank' : null"
              :rel="c.blank ? 'noopener' : null"
              class="subList"
              :class="{ 'nav-list--active': l2 === ci && hasChildren(c) }"
              @mouseenter="pickL2(ci)"
            >{{ c.title }}</a>
          </div>
        </div>

        <div class="subMenu sub-3" :class="{ 'is-open': level3.length > 0 }">
          <div class="subContent third" :class="{ 'subContent--dense': level3.length > 4 }">
            <a
              v-for="(c, ci) in level3"
              :key="'l3' + ci"
              :href="link(c)"
              :target="c.blank ? '_blank' : null"
              :rel="c.blank ? 'noopener' : null"
              class="subList"
            >{{ c.title }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BUILDING_SYSTEMS } from '../../data/building-pipe'

export default {
  props: {
    activeId: {
      type: [Number],
      default: 0
    }
  },
  data () {
    return {
      // 鼠标当前展开的一级菜单下标，-1 为全部收起
      open: -1,
      l1: 0,
      l2: 0,
      isfixTab: false,
      navList: [
        {
          title: '产品与技术',
          href: '',
          children: [
            {
              title: '全屋活水解决方案',
              href: '/product-solution',
              children: [
                { title: '六维全面水管理体系', href: '/product-six-dimensional' },
                {
                  title: '给水系统',
                  href: '/product-supply-system',
                  children: [
                    { title: '贝瑞斯系列', href: '/product-supply-system#p1' },
                    { title: '普乐仕系列', href: '/product-supply-system#p2' },
                    { title: '梵尔西/伊耐斯系列', href: '/product-supply-system#p3' },
                    { title: '法斯特系列', href: '/product-supply-system#p4' },
                    { title: '住宅给水阀门系列', href: '/product-supply-system#p5' },
                    { title: '工程不锈钢系列', href: '/product-supply-system#p6' }
                  ]
                },
                { title: '排水系统', href: '/product-drainage-system' }
              ]
            },
            {
              // 按《菜单目录》要求：一级项本身不再外链 cbpipe.com，只作为二级菜单的入口
              title: '建筑管路系统综合解决方案',
              href: '',
              children: BUILDING_SYSTEMS.map(s => ({ title: s.name, href: s.path }))
            },
            { title: '流体控制解决方案', href: 'http://www.ibpchina.com/', blank: true }
          ]
        },
        {
          title: '班管家服务',
          href: '',
          children: [
            { title: '班管家365服务', href: '/service' },
            { title: '班管家服务平台', href: 'https://oms.idcgroup.com.cn:8082/BGJGZH/index.html', blank: true },
            { title: '班管家系统配置', href: '/service2' }
          ]
        },
        {
          title: '舒享水生活',
          href: '',
          children: [
            { title: '知水擅水', href: '/life' },
            { title: '展厅预约', href: '/appointment' }
          ]
        },
        {
          title: '探索班尼戈',
          href: '',
          children: [
            { title: '关于班尼戈', href: '/about' },
            { title: '百年传承', href: '/explore' },
            { title: '新闻动态', href: '/news' },
            {
              title: '优秀案例',
              href: '',
              children: [
                { title: '全球案例', href: '/global-case' },
                { title: '中国案例', href: '/china-case' }
              ]
            },
            { title: '联系我们', href: '/contact' }
          ]
        }
      ]
    }
  },
  computed: {
    level1 () {
      const item = this.navList[this.open]
      return (item && item.children) || []
    },
    level2 () {
      const item = this.level1[this.l1]
      return (item && item.children) || []
    },
    level3 () {
      const item = this.level2[this.l2]
      return (item && item.children) || []
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleTabFix, true)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleTabFix, true)
  },
  methods: {
    link (item) {
      return item.href || 'javascript:;'
    },
    hasChildren (item) {
      return !!(item && item.children && item.children.length)
    },
    /** 展开某个一级菜单，并把下级默认停在第一个“有下级”的项上 */
    openMenu (index) {
      this.open = index
      this.l1 = this.firstWithChildren(this.navList[index] && this.navList[index].children)
      this.$nextTick(() => { this.l2 = this.firstWithChildren(this.level2) })
    },
    closeMenu () {
      this.open = -1
    },
    pickL1 (i) {
      this.l1 = i
      this.$nextTick(() => { this.l2 = this.firstWithChildren(this.level2) })
    },
    pickL2 (i) {
      this.l2 = i
    },
    firstWithChildren (list) {
      if (!list || !list.length) return 0
      for (let i = 0; i < list.length; i++) {
        if (this.hasChildren(list[i])) return i
      }
      return 0
    },
    handleTabFix () {
      const el = document.querySelector('#testNavBar')
      if (!el) return
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this.isfixTab = scrollTop > el.offsetTop
    }
  }
}
</script>

<style scoped lang="less">
</style>
